module.exports = __webpack_public_path__ + "media/images/logo-967cf32f5e1a6d10524ceeea220142a9.svg";